import React from "react";
// Local components
import GoldTransaction from "./components/GoldTransaction";
import Financials from "./components/Financials";

const Starter: React.FC = () => {
	return (
		<div className="container">
			<GoldTransaction />
			<Financials />
		</div>
	);
};

export default Starter;
